// extracted by mini-css-extract-plugin
export default {};
    if(module.hot) {
      // 1790680669239
      var cssReload = require("/home/garphild.pro/web/drones.garphild.pro/private/nodeapp/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  